module.exports = __webpack_public_path__ + "img/2025-02_impact.897e69f7.webp";